// API Error types
export interface ApiError {
  message: string;
  status?: number;
  field?: string;
}

export function toApiError(error: unknown): ApiError {
  // We narrow progressively instead of using any.
  const maybe = error as
    | {
        response?: {
          data?: { message?: string; field?: string };
          status?: number;
        };
        message?: string;
      }
    | undefined;
  if (maybe?.response?.data?.message) {
    return {
      message: maybe.response.data.message,
      status: maybe.response.status,
      field: maybe.response.data.field,
    };
  }
  if (maybe?.message) {
    return { message: maybe.message };
  }
  return { message: "An unexpected error occurred" };
}

// Pagination types
export interface PaginationInfo {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: PaginationInfo;
}

// Admin filter types
export interface AdminTextFilters {
  language?: string;
  difficulty?: string;
  userId?: string;
  search?: string;
}

export interface AdminUserFilters {
  role?: string;
  subscription?: string;
  search?: string;
}

export interface AdminVoiceFilters {
  language?: string;
  tier?: string;
  status?: string;
}
